import _ from 'lodash';
import { PRICE_SELECTED } from 'shared/data/quoteSteps';

export const extractAssembly = (args) => {
  const { quoteStep, parameters, quote, addingToCart } = args;

  if (quoteStep !== PRICE_SELECTED) return {
    quoteStep,
  };

  const {
    row_selected,
    column_selected,
    supplier_selected,
    currentVariant,
  } = parameters;

  const lineItem = quote.line_items.find((li) => li.product_key === supplier_selected);
  if (!lineItem) return {};

  const price = _.round(lineItem.pricing[row_selected][column_selected], 2) || 0;
  const quantity = lineItem.quantities[row_selected];
  const leadTime = lineItem.lead_times[column_selected];

  const unitPrice = _.round((price / quantity), 2);
  return {
    addingToCart,
    quantity,
    leadTime,
    unitPrice,
    parameters,
    lineItemId: lineItem.id,
    supplier: supplier_selected,
    totalPrice: price,
    currentVariant,
  };
};
